import React, { Fragment } from "react";

import { HomeContent, NavBar } from "../components";

const Home = () => (
  <Fragment>
    <NavBar />
    <div className="container flex-grow-1">
      <HomeContent />
    </div>
  </Fragment>
);

export default Home;
